/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf, string, number,
    func, shape, oneOfType,
} from 'prop-types';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const OccasionDropdown = (props) => {
    const { holidays, selected, onChange } = props;
    const defaultSelectValue = holidays[0].id;
    return (
        <Select
            value={selected || defaultSelectValue}
            className="select-wrapper occasion-dropdown margin-bottom-2x"
            onChange={onChange}
            inputProps={{
                classes: {
                    select: 'select-class',
                    root: 'select-root',
                    icon: 'select-icon',
                },
            }}
        >
            {holidays.map((d) => (
                <MenuItem key={d.id} value={d.id}>
                    {d.name}
                </MenuItem>
            ))}
        </Select>
    );
};

OccasionDropdown.propTypes = {
    holidays: arrayOf(
        shape({
            id: oneOfType([number, string]),
            name: string,
        }),
    ).isRequired,
    onChange: func.isRequired,
    selected: string.isRequired,
};

export default OccasionDropdown;
